export default __webpack_public_path__ + "static/media/2018.44b48e97.png";